export default {
  meta: {
    title: '一分钟了解LOCATION',
  }
};
